module.exports = __webpack_public_path__ + "static/video-fcf85f31a9008fd001c21d1168d4b0b9.mp4";